import { Controller } from "@hotwired/stimulus"
import { lock, unlock } from "../helpers/body_scroll_lock"

// A modal that renders already-open and removes itself from the DOM on close.
// Use for one-shot modals appended via Turbo Stream.
//
// Wire with: data-controller="transient-modal"
//            data-action="click->transient-modal#dismissOnBackdrop"
// Close button: data-action="click->transient-modal#dismiss"
export default class extends Controller {
  connect() {
    lock()
    this.previouslyFocused = document.activeElement
    const focusable = this.element.querySelector(
      "button:not([disabled]), a, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
    )
    focusable?.focus()
  }

  disconnect() {
    unlock()
    if (this.previouslyFocused?.focus) {
      try { this.previouslyFocused.focus() } catch { /* element gone — no-op */ }
    }
  }

  dismiss() {
    this.element.remove()
  }

  dismissOnBackdrop(event) {
    if (event.target === event.currentTarget) this.dismiss()
  }
}
